import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

export const FulfillmentOrderIntegrationSourceSchema = z
  .object({ integrationId: z.string().meta({ privacy: privacy.nonPii }) })
  .meta({ privacy: privacy.structured });
